import {FormLabel} from "@chakra-ui/react";

export interface FieldLabelProps {
    text: string;
}

export const FieldLabel = (props: FieldLabelProps) => (
    <FormLabel fontWeight={300} color="gray">{props.text}</FormLabel>
);